import { render, staticRenderFns } from "./GroupSelectedInformer.vue?vue&type=template&id=8b10b8ee&scoped=true&"
import script from "./GroupSelectedInformer.vue?vue&type=script&lang=ts&"
export * from "./GroupSelectedInformer.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSelectedInformer.vue?vue&type=style&index=0&id=8b10b8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b10b8ee",
  null
  
)

export default component.exports